import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import type { ReactNode } from "react";
import { LogoMark } from "../branding/LogoMark";

export interface AuthBrandPanelProps {
  appName: ReactNode;
  tagline?: ReactNode;
}

/**
 * Decorative side panel shown alongside the auth form on wide screens.
 * `AuthShell` paints the brand gradient across the *whole* page when this is
 * present - this component only owns its own (white) text color, not a
 * background, so the left and right halves read as one continuous surface.
 */
export function AuthBrandPanel({ appName, tagline }: AuthBrandPanelProps) {
  return (
    <Box
      sx={{
        display: { xs: "none", md: "flex" },
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        gap: 2,
        width: "50%",
        px: 8,
        color: "#ffffff",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: 88,
          height: 88,
          borderRadius: 3,
          bgcolor: "rgba(255, 255, 255, 0.92)",
          mb: 1,
        }}
      >
        <LogoMark size={60} />
      </Box>
      <Typography variant="h3" sx={{ fontWeight: 800 }}>
        {appName}
      </Typography>
      {tagline ? (
        <Typography variant="body1" sx={{ opacity: 0.9, maxWidth: 420 }}>
          {tagline}
        </Typography>
      ) : null}
    </Box>
  );
}
